const DAY_MS = 86400000;
export const ISO_WEEKDAYS_SV = [
    "Måndag",
    "Tisdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lördag",
    "Söndag",
];
export const ISO_WEEKDAYS_SV_SHORT = [
    "Mån",
    "Tis",
    "Ons",
    "Tor",
    "Fre",
    "Lör",
    "Sön",
];
export const ISO_WEEKDAYS_EN = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];
export function toIsoDate(d) {
    const y = d.getFullYear();
    const m = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    return `${y}-${m}-${day}`;
}
export function fromIsoDate(s) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
    if (!m)
        return null;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    if (mo < 1 || mo > 12 || d < 1 || d > 31)
        return null;
    const out = new Date(y, mo - 1, d);
    if (out.getFullYear() !== y ||
        out.getMonth() !== mo - 1 ||
        out.getDate() !== d)
        return null;
    return out;
}
export function isoWeekdayIndex(d) {
    return (d.getDay() + 6) % 7;
}
function utcOf(d) {
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
}
export function isoWeekParts(date) {
    const d = utcOf(date);
    const dayIdx = (d.getUTCDay() + 6) % 7;
    d.setUTCDate(d.getUTCDate() - dayIdx + 3);
    const year = d.getUTCFullYear();
    const jan4 = new Date(Date.UTC(year, 0, 4));
    const jan4Idx = (jan4.getUTCDay() + 6) % 7;
    const week1Monday = new Date(jan4);
    week1Monday.setUTCDate(jan4.getUTCDate() - jan4Idx);
    const week = Math.round((d.getTime() - week1Monday.getTime()) / (7 * DAY_MS)) + 1;
    return { year, week };
}
export function isoWeek(date) {
    return isoWeekParts(date).week;
}
export function isoWeeksInYear(year) {
    return isoWeekParts(new Date(year, 11, 28)).week;
}
export function mondayOfIsoWeek(year, week) {
    const jan4 = new Date(year, 0, 4);
    const mondayOfWeek1 = new Date(jan4);
    mondayOfWeek1.setDate(jan4.getDate() - isoWeekdayIndex(jan4));
    const out = new Date(mondayOfWeek1);
    out.setDate(mondayOfWeek1.getDate() + (week - 1) * 7);
    return out;
}
export function isoWeekDates(year, week) {
    const monday = mondayOfIsoWeek(year, week);
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(monday);
        d.setDate(monday.getDate() + i);
        return toIsoDate(d);
    });
}
export function shiftIsoWeek(year, week, delta) {
    const monday = mondayOfIsoWeek(year, week);
    monday.setDate(monday.getDate() + delta * 7);
    return isoWeekParts(monday);
}
export function isoWeekKey(year, week) {
    return year * 100 + week;
}
